import React, {PureComponent} from "react"
import {translate} from "react-i18next"
import PropTypes from "prop-types"

import styles from "../styles.css"

class NotificationMailSwitch extends PureComponent {
  static propTypes = {
    initialValue: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    updating: PropTypes.bool
  }

  static defaultProps = {
    onSubmit: value => console.log(value),
    updating: false
  }

  state = {
    edit: false,
    changed: false,
    selectedValue: ""
  }

  constructor(props) {
    super(props)

    this.switchEditMode = this.switchEditMode.bind(this)
    this.setValue = this.setValue.bind(this)
    this.submitValue = this.submitValue.bind(this)
  }

  setValue(value) {
    this.setState(prevState => {
      return {
        ...prevState,
        changed: true,
        selectedValue: value
      }
    })
  }

  submitValue() {
    if (
      this.state.changed &&
      this.state.selectedValue !== this.props.initialValue
    ) {
      this.props.onSubmit(this.state.selectedValue)
    }

    this.switchEditMode()
  }

  switchEditMode() {
    this.setState(prevState => {
      return {
        ...prevState,
        edit: !prevState.edit
      }
    })
  }

  render() {
    const {initialValue, updating, t} = this.props
    const {selectedValue} = this.state

    if (updating) {
      return (
        <div className={styles.DefaultLangSwitch}>
          <span className="loading">...</span>
        </div>
      )
    }

    const values = {
      no: t("Nein"),
      yes: t("Ja")
    }

    return (
      <div className={styles.DefaultLangSwitch}>
        {this.state.edit ? (
          <span>
            <select
              defaultValue={initialValue}
              onChange={e => this.setValue(e.target.value)}
            >
              <option value="yes">{t("Ja")}</option>
              <option value="no">{t("Nein")}</option>
            </select>
            <button className="button accept-button" onClick={this.submitValue}>
              <i className="icon-quiz-feedback-right" />
            </button>
            <button
              className="button deny-button"
              onClick={this.switchEditMode}
            >
              <i className="icon-quiz-feedback-wrong" />
            </button>
          </span>
        ) : (
          <span>
            <span>
              {selectedValue === ""
                ? values[initialValue]
                : values[selectedValue]}
            </span>
            <button
              className="button edit-button"
              onClick={this.switchEditMode}
            >
              <i className="icon-edit" />
            </button>
          </span>
        )}
      </div>
    )
  }
}

export default translate()(NotificationMailSwitch)



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserInformation/notificationMailSwitch.js